
export enum ComponentType {
    FLAG_ONLY = "flagOnly",
    FULL_INPUT_COMBINED = "fullInputCombined",
    FULL_INPUT_SEPERATED = "fullInputSeperated"
  }